import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';
import '../styles/Auth.css';

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [totpCode, setTotpCode] = useState('');
  const [challengeToken, setChallengeToken] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handlePasswordSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await authAPI.adminLogin(String(username).trim(), password);
      const data = response.data;

      if (data.totp_required) {
        setChallengeToken(data.challengeToken);
      } else {
        login(data.user, data.token);
        navigate('/admin');
      }
    } catch (err) {
      setError(err?.response?.data?.error || err.message || 'Admin login failed');
    } finally {
      setLoading(false);
    }
  };

  const handleTotpSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await authAPI.adminTotpVerify(challengeToken, totpCode.replace(/\s/g, ''));
      const { token, user } = response.data;
      login(user, token);
      navigate('/admin');
    } catch (err) {
      const msg = err?.response?.data?.error || err.message || 'TOTP verification failed';
      setError(msg);
      // If the challenge token expired, send them back to password step
      if (msg.toLowerCase().includes('expired') || msg.toLowerCase().includes('invalid session')) {
        setChallengeToken(null);
        setTotpCode('');
      }
    } finally {
      setLoading(false);
    }
  };

  if (challengeToken) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <h1>🛡️ Admin Portal</h1>
          <h2>Two-Factor Authentication</h2>
          <p style={{ color: '#aaa', fontSize: '0.9rem', marginBottom: '1rem' }}>
            Open your authenticator app and enter the 6-digit code.
          </p>

          {error && <div className="error-message">{error}</div>}

          <form onSubmit={handleTotpSubmit}>
            <input
              type="text"
              inputMode="numeric"
              placeholder="000 000"
              value={totpCode}
              onChange={(e) => setTotpCode(e.target.value)}
              maxLength={7}
              autoFocus
              required
              style={{ letterSpacing: '0.2em', fontSize: '1.4rem', textAlign: 'center' }}
            />
            <button type="submit" disabled={loading || totpCode.replace(/\s/g, '').length < 6}>
              {loading ? 'Verifying...' : 'Verify'}
            </button>
          </form>

          <p style={{ marginTop: '1rem' }}>
            <button
              type="button"
              onClick={() => { setChallengeToken(null); setError(''); setTotpCode(''); }}
              style={{ background: 'none', border: 'none', color: '#888', cursor: 'pointer', textDecoration: 'underline' }}
            >
              Back to login
            </button>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1>🛡️ Admin Portal</h1>
        <h2>Admin Login</h2>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handlePasswordSubmit}>
          <input
            type="text"
            placeholder="Admin Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Login as Admin'}
          </button>
        </form>

        <p>
          Regular player? <Link to="/login">Go to player login</Link>
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
